// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-draft-sent{z-index:20000 !important}.dialog-draft-sent .button-warning-decision{width:100px}\n", ""]);
// Exports
module.exports = exports;
